const IVAN_RAMEN_VENUE_ID ='c60be317-c993-4c66-8426-91fff36d45ea';
const SESSIONS_HEAD_OFFICE_VENUE_ID='0c4c3cd7-c398-4eb6-969c-86eea3e64de2';

export { IVAN_RAMEN_VENUE_ID, SESSIONS_HEAD_OFFICE_VENUE_ID };
